import script from "./ChatListHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatListHistory.vue?vue&type=script&setup=true&lang=ts"

import "./ChatListHistory.vue?vue&type=style&index=0&id=0f188843&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f188843"]])

export default __exports__